app.controller('newsletter', ['$scope', '$http', function ($scope, $http) {
    $scope.email = '';
    $scope.success = false;
    $scope.posts = JSON.parse(document.querySelector('#data').value);
    $scope.filter = document.querySelector('#filter').value;
    $scope.category = 'All';
    $scope.scrollClass = false;
    $scope.article = document.getElementsByClassName('article-container')[0];

    var months = {1:'January', 2:'February', 3:'March', 4:'April', 5:'May', 6:'June', 7:'July', 8:'August', 9:'September', 10:'October', 11:'November', 12:'December'};

    $scope.subscribe = function(){
        $http.post('/newsletter/subscribe', {email:$scope.email})
            .success(function(data) {
              $scope.success = data;
              $scope.email = '';
            });
    }

    $scope.convertDate = function(date) {
    	var x = date.split(' ');
    	x = new Date(x[0]);
    	return $scope.getOrdinal(x.getDate()) + ' ' + months[parseInt(x.getMonth()+1)] + ' ' + x.getFullYear();
    }

    $scope.getOrdinal = function(day) {
        var suffixes = ['th', 'st', 'nd', 'rd'];
        var x = day%100;
        return day + (suffixes[(x-20)%10]||suffixes[x]||suffixes[0]);
    }

    // $scope.yearFilter = function(year) {
    // 	$scope.category = year;
    //     $scope.visibleCount = 0;
    // 	for(i = 0; i < $scope.posts.length; i++)
    // 	{
    // 		if(year == 'All') {
    // 			$scope.posts[i].visible = true;
    //         }
    // 		else
    // 		{
    // 			date = new Date($scope.posts[i].post_date);
	   //  		if(date.getFullYear() != year) {
	   //  			$scope.posts[i].visible = false;
	   //  		} else {
    //                 $scope.posts[i].visible = true;
    //                 $scope.visibleCount++;
    //                 if($scope.visibleCount == 1) {
    //                 } else {
    //                 }
    //             }
    // 		}
    // 	}
    //     $scope.filterShow = false;
    // }

    // $scope.yearFilter($scope.filter);
}]);

app.directive("scroll", function ($window) {
    return function(scope, element, attrs) {
        angular.element($window).bind("scroll", function() {
             if (this.pageYOffset >= document.getElementsByClassName('article-container')[0].offsetHeight) {
                 scope.hideSocial = true;
             } else {
                 scope.hideSocial = false;
             }
            scope.$apply();
        });
    };
});
